import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["absentFields", "lateFields", "statusRadio"]

  statusChanged() {
    const selectedRadio = this.statusRadioTargets.find((radio) => radio.checked)
    if (!selectedRadio) return

    const status = selectedRadio.value

    // Toggle absent fields
    if (this.hasAbsentFieldsTarget) {
      this.absentFieldsTarget.classList.toggle("hidden", status !== "absent")
    }

    // Toggle late fields
    if (this.hasLateFieldsTarget) {
      this.lateFieldsTarget.classList.toggle("hidden", status !== "late")
    }

    // Dispatch event for parent controller to update counters
    this.dispatch("statusChanged", { detail: { status } })
  }
}
